import type { Environment } from './environment.interface';

export const environment: Environment = {
  production: false,
  apiUrl: 'https://api-dev.fmc-onboarding.enteldigital.cl',
  firebaseConfig: {
    apiKey: 'AIzaSyCwLFlGHfwPJHRUR156yvHuRiucdHdd59g',
    authDomain: 'follow-my-car-dev.firebaseapp.com',
    projectId: 'follow-my-car-dev',
    storageBucket: 'follow-my-car-dev.firebasestorage.app',
    messagingSenderId: '766371095268',
    appId: '1:766371095268:web:48555e35a1900c961002f1',
    measurementId: 'G-0NEZYSZPLC',
  },
  wizardStateTtlMs: 10 * 60 * 1000, // 10 minutes for development
  useMockVerification: false,
  clientOrigin: 'f6dcf701b8d6a4eae9c8bef901559c449b530aae4a816a5e9f84f3648ed72d3b',
  recaptchaSiteKey: '6LdA5ZcsAAAAAO09PQl9bV97VYtQFv7mfKkBhR5M',
  magicLinkRedirectUrl: 'https://onboarding-fmc-dev.web.app/auth/complete',
  magicLinkFunctionName: 'sendmagiclinkemail',
  magicLinkTemplateName: 'magic-link-onboarding',
  magicLinkMode: 'params',
  fmcWebUrl: 'https://app.fmc-beta.entelocean.io/#/fmc/car',
};
